// extracted by mini-css-extract-plugin
module.exports = {"dateWrapper":"_7411770","dateContainer":"_6f7709c"};